export default __webpack_public_path__ + "static/media/whiteFront2.296e3ea5.png";